import { TParadiseLLMPromptCategory } from "src/data/paradise/paradiseLLMPrompts/types/paradiseLLMPromptsQueryTypes"

export function parseParadiseLLMPromptsCategory(
  category: string | undefined
): TParadiseLLMPromptCategory | undefined {
  if (!category) {
    return undefined
  }

  // Since we're fetching categories from the API, we'll be more permissive
  // and let the API handle the final validation
  return category as TParadiseLLMPromptCategory
}

export function isVaildParadiseLLMPromptsCategory(
  category: string | undefined
): category is TParadiseLLMPromptCategory {
  return !!parseParadiseLLMPromptsCategory(category)
}
